<template>
    <v-container container--fluid>
        <v-layout v-if="!plansLoaded" row wrap class="pa-2 mx-auto full-height">
            <v-flex xs12 class="justify-center text-center mt-12">
                <span class="font-weight-bold title">Loading Data... <i class="fas fa-circle-notch fa-spin"></i></span>
            </v-flex>
        </v-layout>
        <v-layout v-if="plansLoaded" row wrap align-center justify-space-around class="pb-16 pt-8 px-3 mx-auto">
            <v-flex xs12 class="text-left">
                <v-row>
                    <v-col cols="12" sm="12" md="12" class="" order="2" order-sm="1">
                        <v-row v-if="plans_list.length > 0">
                            <v-col class="pa-1 mb-4 d-flex justify-start" cols="12">
                                <h1 class="grey--text lighten-3 align-self-center">Plans</h1>
                            </v-col>
                            <v-col class="pa-1" cols="12" sm="12" md="6" lg="6" v-for="(plan, index) in plans_list" :key="index">
                                <v-card class="mx-auto" max-width="680" height="100%" rounded raised>
                                    <v-list three-line>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title class="headline mb-1">{{ plan.plan_name }}</v-list-item-title>
                                                <v-list-item-subtitle class="secondary--text text--darken-4">
                                                    <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">monetization_on</v-icon>Price: {{ plan.plan_price | currency }} &nbsp; - &nbsp;<v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">event_note</v-icon><span class="text-capitalize">Billing Cycle: {{ plan.plan_billing_cycle }}</span> &nbsp; - &nbsp;<v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">event_note</v-icon><span class="text-capitalize">Auto Renewal: {{ plan.plan_auto_renewal}}</span>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class="secondary--text text--darken-4">
                                                    <v-icon v-if="!plan.plan_sliding_date" left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">event_note</v-icon><span v-if="!plan.plan_sliding_date">Expiry: {{ plan.plan_expiry_period }}</span><v-icon v-if="plan.plan_sliding_date" left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">event_note</v-icon><span v-if="plan.plan_sliding_date">Start: {{ plan.plan_start_date }} &nbsp; - &nbsp;</span><span v-if="plan.plan_sliding_date">End: {{ plan.plan_end_date }}</span>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class="secondary--text text--darken-4">
                                                    <v-icon v-if="plan.plan_excluded_date" left small color="secondary darken-4" size="18" style="margin-top: -2px; margin-right: 4px;">calendar_today</v-icon><span v-if="plan.plan_excluded_date">Excluded Dates: {{ plan.plan_excluded_date }}</span>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-avatar tile size="80" color="primary">
                                                <v-img v-if="plan.plan_cover" :src="plan.plan_cover" :alt="plan.plan_name" cover></v-img>
                                            </v-list-item-avatar>
                                        </v-list-item>
                                        <v-list-item three-line class="line-clamp-4">
                                            <v-list-item-content class="align-start">
                                                <v-list-item-subtitle>{{ plan.plan_description }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>

                                    <v-card-actions>
                                        <v-btn
                                            color="primary lighten-1"
                                            class="px-2 py-1"
                                            small
                                            :to="{ name: 'planPayment', params: { plan_id: plan.plan_id } }"
                                        >
                                            <v-icon left small>subscriptions</v-icon>Subscribe
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="justify-center" v-if="plans_list.length == 0">
                            <v-col cols="12" sm="6" class="mt-6">
                                <v-alert color="secondary" style="font-size: 18px;" dense outlined text type="info">No plans are currently available.</v-alert>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
// import moment from 'moment';

export default {
    name: "PlansModule",
    components: {
        //
    },
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        plans_list: [],
        plansLoaded: false,
    }),
    computed: {
        plansLoading(){
            return this.$store.getters['plans/planStatus'] == 'loading';
        },
        plans(){
            return this.$store.getters['plans/plans'];
        },
    },
    methods: {
        total(price){
            return parseFloat(price);
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');

        this.$store.dispatch('plans/plansRequest').then(() => {
            this.plans_list = this.plans;
            this.plansLoaded = true;
        });
    },
};
</script>

<style scoped>

</style>
